export const config = {
  abiStoreUrl: 'https://static.polygon.technology/network/',
  zkEvmBridgeService: 'https://proof-generator.polygon.technology/'
};
